import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachHoSoCongViec: [],
  chiTietHoSoCongViec: {},
  doiTuongDuocTraLai: [],
  treeDonVi: [],
  treePhanXuLy: [],
  lichSuThuHoi: [],
  lichSuPhanXuLy: [],
  lichSuTraLai: [],
  lichSuCapNhatTinhHinhThucHien: [],
  luongXuLy: [],
  countList: {},
  treeDaPhanXuLy: [],
  treeDaPXLSearchData: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
